<footer>
    <p class="text-base text-gray-400 font-normal p-3 text-center">
        iTagTip 2015 - 2025. All Rights Reserved.
    </p>
</footer>